import React, { useState, createContext } from "react";
import QuickReplyData from "./QuickReplyData";

export const QuickReplyContext = createContext();

export const QuickReplyContextProvider = (props) => {
    const [data, setData] = useState(QuickReplyData);
    
    return <QuickReplyContext.Provider value={{contextData: [data, setData]}}>{props.children}</QuickReplyContext.Provider>
}